<template>
  <el-row class="home-container">
    <div class="base-wrapper sell-faster">
      <el-button
        class="primary-button close"
        icon="icon-x"
        @click="$router.push({ name: 'Home' })"
      />
      <div class="header-wrapper">
        <div class="inner">
          <i class="icon-checked" />
          <h1 class="title">
            {{ $t('feature-ad.congratulations.title') }}
          </h1>
          <span class="sub-title">{{ $t( 'feature-ad.congratulations.subtitle' ) }}</span>
        </div>
      </div>
      <el-button
        class="primary-button submit"
        @click="onSubmit"
      >
        {{ $t('feature-ad.congratulations.send.text') }}
      </el-button>
    </div>
  </el-row>
</template>

<script>
export default {
  methods: {
    onSubmit() {
      this.$router.push({ name: 'Home' });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Congratulations.vue